import { ComponentProps } from 'react';
import styled from '@emotion/styled';
import { Flex } from '@qga/roo-ui/components';
import { themeGet } from 'styled-system';

const StyledFlex = styled(Flex)`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px solid ${themeGet('colors.greys.alto')};
  z-index: ${themeGet('zIndices.foreground')};
  background-color: ${themeGet('colors.white')};

  > * {
    flex: 1 1 auto;
  }
`;

const StickyFooter = ({
  children,
  ...rest
}: ComponentProps<typeof StyledFlex>) => (
  <StyledFlex {...rest} data-testid="STICKY_FOOTER">
    {children}
  </StyledFlex>
);

export default StickyFooter;
